import axios from 'axios';

const instance = axios.create({
    baseURL: 'https://campaign.fundall.io',
    timeout: 100000,
    headers: {
        'Accept': 'application/json',
        'Content-Type': 'application/json',
    }
  });

  export default instance